import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getFeatureFlagsData } from '../actions/featureFlags/featureFlags';


/**
 * This takes in a list of feature flag names and
 * returns the data for enabled feature flags
 * @param {*} featureNames 
 * @returns 
 */
export default function useEnabledFeatureFlags(featureNames) {
  const dispatch = useDispatch();

  const { featureFlagsData, loading } = useSelector(
    (state) => state?.featureFlags
  );

  useEffect(() => {
    dispatch(getFeatureFlagsData());
  }, [dispatch]);
  
  // Create a feature flag mapping of features fetched from api call
  const featureFlagMapping = (featureFlagsData || []).reduce(
    (acc, item) => ({ ...acc, ...{[item.name.toLowerCase()]: item }}),
    {},
  );

  const activeFeatures = featureNames?.map((item) => {
    const featureFlag = featureFlagMapping[item?.toLowerCase()];
    return (featureFlag && featureFlag.isEnabled === true) ? featureFlag : {}
  });

  return activeFeatures;
}